var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 28 28",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8436 9.27742L20.7577 6.75342L18.1507 5.61371L20.7577 4.4807L21.8436 2.06885L22.9295 4.4807L25.5365 5.61371L22.9295 6.75342L21.8436 9.27742ZM21.8436 25.9136L20.7577 23.4726L18.1507 22.3508L20.7577 21.2178L21.8436 18.6759L22.9295 21.2178L25.5365 22.3508L22.9295 23.4726L21.8436 25.9136ZM9.7911 21.1975L7.48918 16.237L2.44568 13.9823L7.48918 11.7275L9.7911 6.78489L12.1109 11.7275L17.1365 13.9823L12.1109 16.237L9.7911 21.1975ZM9.7911 17.9355L11.1238 15.214L13.8923 13.9823L11.1238 12.7505L9.7911 10.029L8.47635 12.7505L5.68983 13.9823L8.47635 15.214L9.7911 17.9355Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.c32d995d60c8acd1608371aa741b9222.svg";
export { ForwardRef as ReactComponent };